export type UserRole =
  | 'employee'
  | 'supervisor'
  | 'manager_l1'
  | 'manager_l2'
  | 'area_supervisor'

export type DataMode = 'mock' | 'supabase-dev'

export interface SessionUser {
  id: string
  name: string
  storeName: string
  role: UserRole
  roleLabel: string
  level: number
}

export interface HomeSnapshot {
  announcement: { id: string; title: string; summary: string }
  tasks: Array<{ id: string; label: string; completed: boolean }>
  dailyLetter: string
}

export function hasAnnouncement(snapshot: HomeSnapshot, announcementId: string): boolean {
  return snapshot.announcement.id === announcementId
}

export interface TrainingModule {
  id: string
  title: string
  description: string
  progress: number
  status: 'completed' | 'in_progress' | 'not_started'
  areas: {
    academic: TrainingAreaStatus
    practical: TrainingAreaStatus
    teaching: TrainingAreaStatus
  }
}

export type TrainingAreaState = 'completed' | 'in_progress' | 'not_started' | 'pending_review' | 'unknown'

export interface TrainingAreaStatus {
  state: TrainingAreaState
  label: string
  progress: number
}

export interface RevenueSnapshot {
  annualRevenue: number
  annualTarget: number
  stage: string
  rankings: Array<{ rank: number; store: string; revenue: number; rate: number }>
}

export interface ThanksActivity {
  id: string
  from: string
  to: string
  type: 'warmth' | 'wisdom' | 'reliability'
  message: string
  occurredAt: string
}

export interface BadgeSummary {
  id: string
  name: string
  category: string
  earned: boolean
  description: string
}

export interface AppNotification {
  id: string
  kind: 'broadcast' | 'training' | 'badge' | 'thanks'
  title: string
  time: string
  read: boolean
  target: string
}

export interface DocumentSummary {
  id: string
  title: string
  category: 'SOP' | '規章' | '公告'
  acknowledged: boolean
}

export interface AppAdapter {
  readonly mode: DataMode
  getSession(): Promise<SessionUser | null>
  getHome(): Promise<HomeSnapshot>
  getTrainingModules(): Promise<TrainingModule[]>
  getRevenue(): Promise<RevenueSnapshot>
  getThanksActivity(): Promise<ThanksActivity[]>
  getBadges(): Promise<BadgeSummary[]>
  getNotifications(): Promise<AppNotification[]>
  getDocuments(): Promise<DocumentSummary[]>
}

export class AdapterUnavailableError extends Error {
  constructor(message = '資料來源尚未接線') {
    super(message)
    this.name = 'AdapterUnavailableError'
  }
}
